export const DEFAULT_SECTIONS = {
    "Indications And Usage": "None",
    "Dosage": "None",
    "Contraindications": "None",
    "Adverse Reactions": "None",
    "Drug Interactions": "None",
    "Storage": "None",
    "Mechanism Of Action": "None",
    "Efficacy": "None"
};

export const normalizeSections = (sections = {}) => {
    const safeSections = {};

    // normalize incoming keys (trim + lowercase)
    Object.keys(sections || {}).forEach((key) => {
        safeSections[key.trim().toLowerCase()] = sections[key];
    });

    const normalized = {};

    Object.keys(DEFAULT_SECTIONS).forEach((key) => {
        const lookupKey = key.trim().toLowerCase();

        const value = safeSections[lookupKey];

        normalized[key] =
            value !== undefined && value !== null && value !== ""
                ? value
                : "None";
    });

    return normalized;
};